





import Vue, {PropType} from 'vue'
import {Observer} from 'mobx-vue'

import {UtilityItem} from '../../stores/UtilityBar'

import UtilActionItem from './UtilityActionItem.vue'
import UtilWidgetItem from './UtilityWidgetItem.vue'

export default Observer(Vue.extend({
    components: {
        UtilActionItem,
        UtilWidgetItem
    },
    props: {
        item: Object as PropType<UtilityItem>
    }
}))
